import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./Register";

const Register = lazy(() => import("./Register"));

export default (props: Props) => (
  <Page isPublic>
    <Register {...props} />
  </Page>
);
